'use client'

import Check from '@/app/_components/Icon/Check'
import { FilterTitle } from '@/app/_components/Search/Filters/FilterTitle'
import CheckboxBadge from '@/app/_components/Search/SearchResult/CheckboxBadge'
import { cn } from '@/app/_primitives/utils/cn'
import { stringArray } from '@/app/utils/zod_stringArray'
import { useSearchParams } from '@/libraries/search-params'
import React, { useTransition } from 'react'
import { z } from 'zod'
import { PRESET_COLORS } from '../../CharacterRegister/BgColorPicker'
import { FilterSection } from '../Filters/FilterSection'
import Checkbox from './Checkbox'

function ColorButton(props: {
  onClick: () => void
  selectedColor: string
  color: string
}) {
  const [isPending, startTransition] = useTransition()
  const { onClick, color, selectedColor } = props
  return (
    <button
      onClick={() => {
        startTransition(() => {
          onClick()
        })
      }}
      style={{
        background: color,
      }}
      className={cn(
        'flex h-25 w-25 flex-row items-center justify-center rounded-full outline-none focus:outline-none',
        {
          'cursor-wait': isPending,
        },
      )}
      type="button">
      {selectedColor === color && (
        <Check className="size-20 rotate-[10deg] fill-white" />
      )}
    </button>
  )
}

export default function Filters({ children }: { children: React.ReactNode }) {
  const [state, setState] = useSearchParams(
    z.object({
      color: z.string().default(''),
    }),
  )

  return (
    <div className="flex flex-col items-stretch gap-20">
      <FilterTitle />
      <div className="border-b-1 border-b-border-base" />

      {children}
      <div className="border-b-1 border-b-border-base" />

      <CountryFilter />

      <div className="border-b-1 border-b-border-base" />

      <FilterSection title="COLOR">
        <div className="grid grid-cols-5 gap-18">
          {PRESET_COLORS.map((color) => (
            <ColorButton
              onClick={() =>
                setState({
                  color: state.color === color ? '' : color,
                })
              }
              key={color}
              color={color}
              selectedColor={state.color}
            />
          ))}
        </div>
      </FilterSection>
    </div>
  )
}

export function CategoryAndGenreFilters({
  categories,
  genres,
}: {
  categories: Array<{ id: string; name: string; characterCount: number }>
  genres: Array<{ id: string; name: string; characterCount: number }>
}) {
  const [state, setState] = useSearchParams(
    z.object({
      categories: stringArray(),
      genres: stringArray(),
    }),
  )
  return (
    <div className="flex flex-col gap-20">
      <FilterSection
        // title={t('common.categoryGenre')}
        title={'캐릭터 장르'}
        variant="collapsible"
        defaultOpen>
        <div className="flex flex-wrap gap-8">
          {categories.map((category) => (
            <CheckboxBadge
              checked={state.categories.includes(category.id)}
              onChecked={() => {
                setState({
                  categories: state.categories.includes(category.id)
                    ? state.categories.filter((it) => it !== category.id)
                    : [...state.categories, category.id],
                })
              }}
              key={category.id}>
              <p className="c-b4 text-[#4B5157]">{category.name}</p>
            </CheckboxBadge>
          ))}
        </div>
      </FilterSection>
      <div className="border-b-1 border-b-border-base" />

      <FilterSection
        // title={t('common.categoryItem')}
        title={'어울리는 활용 분야'}
        variant="collapsible"
        defaultOpen>
        <div className="flex flex-col gap-12">
          {genres.map((genre) => (
            <Checkbox
              checked={state.genres.includes(genre.id)}
              onChecked={() => {
                setState({
                  genres: state.genres.includes(genre.id)
                    ? state.genres.filter((it) => it !== genre.id)
                    : [...state.genres, genre.id],
                })
              }}
              key={genre.id}>
              <p className="c-b4 text-left text-[#4B5157]">{genre.name}</p>
            </Checkbox>
          ))}
        </div>
      </FilterSection>
    </div>
  )
}

function CountryFilter() {
  const [state, setState] = useSearchParams(
    z.object({
      countryCode: stringArray(),
    }),
  )
  return (
    <FilterSection
      // title={t('common.categoryItem')}
      title={'원작 국가'}
      variant="collapsible"
      defaultOpen>
      <div className="flex flex-col gap-12">
        <Checkbox
          checked={state.countryCode.includes('kr')}
          onChecked={() => {
            setState({
              countryCode: state.countryCode.includes('kr')
                ? state.countryCode.filter((it) => it !== 'kr')
                : [...state.countryCode, 'kr'],
            })
          }}
          key={'kr'}>
          <p className="c-b4 text-left text-[#4B5157]">한국</p>
        </Checkbox>

        <Checkbox
          checked={state.countryCode.includes('us')}
          onChecked={() => {
            setState({
              countryCode: state.countryCode.includes('us')
                ? state.countryCode.filter((it) => it !== 'us')
                : [...state.countryCode, 'us'],
            })
          }}
          key={'us'}>
          <p className="c-b4 text-left text-[#4B5157]">미국</p>
        </Checkbox>

        <Checkbox
          checked={state.countryCode.includes('jp')}
          onChecked={() => {
            setState({
              countryCode: state.countryCode.includes('jp')
                ? state.countryCode.filter((it) => it !== 'jp')
                : [...state.countryCode, 'jp'],
            })
          }}
          key={'jp'}>
          <p className="c-b4 text-left text-[#4B5157]">일본</p>
        </Checkbox>

        <Checkbox
          checked={state.countryCode.includes('etc')}
          onChecked={() => {
            setState({
              countryCode: state.countryCode.includes('etc')
                ? state.countryCode.filter((it) => it !== 'etc')
                : [...state.countryCode, 'etc'],
            })
          }}
          key={'etc'}>
          <p className="c-b4 text-left text-[#4B5157]">기타</p>
        </Checkbox>
      </div>
    </FilterSection>
  )
}
